// adapters/LeafletAdapter.ts
import L from "leaflet";
import type { MapAdapter } from "../core/MapAdapter";
import "leaflet/dist/leaflet.css";
import type { MapViewState } from "../types/MapTypes";
import type { MapLayer } from "../layers/types";

export class LeafletAdapter implements MapAdapter {
  private map?: L.Map;

  init(container: HTMLDivElement) {
    this.map = L.map(container).setView([0, 0], 2);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OSM",
    }).addTo(this.map);
  }

  setView(view: MapViewState) {
    this.map?.setView([view.center[1], view.center[0]], view.zoom);
  }

  setCenter(lng: number, lat: number, zoom = 5) {
    this.map?.setView([lat, lng], zoom);
  }

  setBasemap(cfg: MapLayer | undefined) {}

  getView(): MapViewState {
    return {
      center: [0, 0],
      zoom: 0,
    };
  }

  getMapInstance() {
    return this.map;
  }

  destroy() {
    this.map?.remove();
  }

  resize() {
    this.map?.invalidateSize();
  }

  syncLayers(mapLayers: MapLayer[]): void {}
}
